import clsx from 'clsx';
import { v4 } from 'uuid';

import { EmojiWrapper } from '@/modules/homepage/RenderAlert/EmojiWrapper';
import { LinkButtonsWrapper } from '@/modules/homepage/RenderAlert/LinkButtonsWrapper';
import { AlertInterface, LinkType, ThemeInterface } from '@/types/homepage.types';
import { THEME_LOOKUP } from '@/utils/helpers/constants';

export const RenderAlert = ({
  title,
  description,
  theme,
  emoji,
  links,
  linkUrl,
  linkText,
}: AlertInterface) => {
  const alertTheme: ThemeInterface = theme ? THEME_LOOKUP[theme] : THEME_LOOKUP['purple'];
  const isLongDescription = description.length > 90;
  let linkList: LinkType[] = [];
  if (links) {
    linkList = links;
  } else if (linkUrl && linkText) {
    linkList = [{ id: v4(), linkUrl: linkUrl, linkText: linkText }];
  }

  return (
    <div
      className={clsx(
        'flex flex-col sm:flex-row w-full min-h-[80px] border-8 border-gray-200 items-start sm:items-center rounded-xl shadow-md p-3',
        alertTheme.backgroundColor
      )}
    >
      <div
        className={clsx(
          'flex w-full items-start sm:items-center gap-3',
          isLongDescription ? 'flex-col sm:flex-row' : 'flex-row'
        )}
      >
        <div
          className={clsx(
            'flex p-[10px] sm:p-[15px] justify-center items-center rounded-lg shadow-sm shrink-0',
            alertTheme.emojiBackgroundColor
          )}
        >
          <EmojiWrapper emoji={emoji} />
        </div>
        <div className={clsx('flex flex-col justify-center', alertTheme.textColor)}>
          <div className='flex flex-col gap-1'>
            <h1 className='text-lg sm:text-xl sm:leading-[30px] font-bold'>{title}</h1>
            <p className='text-sm'>{description}</p>
          </div>
          <div className='hidden sm:block'>
            <LinkButtonsWrapper links={linkList} alertTheme={alertTheme} />
          </div>
        </div>
      </div>
      <div className='flex w-full sm:hidden'>
        <LinkButtonsWrapper links={linkList} alertTheme={alertTheme} />
      </div>
    </div>
  );
};
